<template>
  <f7-page>
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/tabs-result/', { reloadCurrent: true })"
        >
          {{ $t('LeftPanel_title_result') }} ({{ resultProject.name }})
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">{{ $t('LeftPanel_subtitle_climate') }}</span>
      </template>
    </navbar>
    <div class="transparent headers-initial">
      <f7-block-title class="block-title-result">
        <span class="color-title-OpenAir">
          {{ `${$t('LeftPanel_subtitle_climate').toUpperCase()}` }}
        </span>
      </f7-block-title>
      <div class="content-charts">
        <div class="chart">
          <DxChart
            id="chart"
            ref="chart1"
            :data-source="data"
            palette="Material"
            @legend-click="onLegendClick"
            @file-saving="onFileSaving"
          >
            <DxCommonSeriesSettings
              type="line"
              argument-field="ddp"
            />
            <DxSeries
              value-field="Tmax"
              name="T max (°C)"
              color="#ed7d31"
            />
            <DxSeries
              value-field="Tmin"
              name="T min (°C)"
              color="#a5a5a5"
            />
            <DxSeries
              value-field="Tmed"
              name="T media (°C)"
              color="#ffc000"
            />
            <DxLegend
              vertical-alignment="bottom"
              horizontal-alignment="center"
              item-text-position="right"
              :visible="true"
            />
            <DxValueAxis
              :show-zero="true"
              position="left"
            >
              <DxTitle text="T (°C)" />
            </DxValueAxis>
            <DxArgumentAxis
              title="Tiempo (días después de trasplante)"
            />
            <DxTitle text="Temperatura" />
            <DxTooltip
              :enabled="true"
              :z-index="999999"
              :customize-tooltip="customizeTooltip"
            />
            <DxExport
              :enabled="true"
              :file-name="`${resultProject.name} - Clima - Temperatura`"
            />
            <DxScrollBar :visible="true" />
            <DxZoomAndPan argument-axis="both" />
          </DxChart>
        </div>
        <div class="chart">
          <DxChart
            id="chart"
            ref="chart2"
            :data-source="data"
            palette="Material"
            @legend-click="onLegendClick"
            @file-saving="onFileSaving"
          >
            <DxCommonSeriesSettings
              type="line"
              argument-field="ddp"
            />
            <DxSeries
              value-field="RHmax"
              name="HRmax (%)"
              color="#ed7d31"
            />
            <DxSeries
              value-field="RHmin"
              name="HRmin (%)"
              color="#ffc000"
            />
            <DxArgumentAxis
              title="Tiempo (días después de trasplante)"
            />
            <DxLegend
              vertical-alignment="bottom"
              horizontal-alignment="center"
              item-text-position="right"
              :visible="true"
            />
            <DxValueAxis
              :show-zero="true"
              position="left"
            >
              <DxTitle text="HR (%)" />
            </DxValueAxis>
            <DxTitle :text="'Humedad Relativa'" />
            <DxTooltip
              :enabled="true"
              :z-index="999999"
              :customize-tooltip="customizeTooltip"
            />
            <DxExport
              :enabled="true"
              :file-name="`${resultProject.name}  - Clima - Humedad Relativa`"
            />
            <DxScrollBar :visible="true" />
            <DxZoomAndPan argument-axis="both" />
          </DxChart>
        </div>
        <div class="chart">
          <DxChart
            id="chart"
            ref="chart3"
            :data-source="data"
            palette="Material"
            @legend-click="onLegendClick"
            @file-saving="onFileSaving"
          >
            <DxCommonSeriesSettings
              type="line"
              argument-field="ddp"
            />
            <DxSeries
              value-field="PRadi"
              name="Rs (MJ / m² / d)"
              color="#ed7d31"
            />
            <DxArgumentAxis
              title="Tiempo (días después de trasplante)"
            />
            <DxLegend
              vertical-alignment="bottom"
              horizontal-alignment="center"
              item-text-position="right"
              :visible="false"
            />

            <DxValueAxis
              :show-zero="true"
              position="left"
            >
              <DxTitle text="Rs (MJ / m² / d)" />
            </DxValueAxis>
            <DxTitle :text="'Radiación Solar Diaria'" />
            <DxTooltip
              :enabled="true"
              :z-index="999999"
              :customize-tooltip="customizeTooltip"
            />

            <DxExport
              :enabled="true"
              :file-name="`${resultProject.name}  - Clima - Radiación Solar Diaria`"
            />
            <DxScrollBar :visible="true" />
            <DxZoomAndPan argument-axis="both" />
          </DxChart>
        </div>
        <div
          class="chart"
          style="padding-bottom: 2rem;"
        >
          <DxChart
            id="chart"
            ref="chart4"
            :data-source="data"
            palette="Material"
            @legend-click="onLegendClick"
            @file-saving="onFileSaving"
          >
            <DxCommonSeriesSettings
              type="line"
              argument-field="ddp"
            />
            <DxSeries
              value-field="eto"
              name="ETo (mm / d)"
              color="#ed7d31"
            />
            <DxArgumentAxis
              title="Tiempo (días después de trasplante)"
            />
            <DxLegend
              vertical-alignment="center"
              horizontal-alignment="left"
              item-text-position="right"
              :visible="false"
            />

            <DxValueAxis
              :show-zero="true"
              position="left"
            >
              <DxTitle text="ETo (mm/d)" />
            </DxValueAxis>
            <DxTitle :text="'ETo Diaria'" />
            <DxTooltip
              :enabled="true"
              :z-index="999999"
              :customize-tooltip="customizeTooltip"
            />
            <DxExport
              :enabled="true"
              :file-name="`${resultProject.name}  - Clima - ETo Diaria`"
            />
            <DxScrollBar :visible="true" />
            <DxZoomAndPan argument-axis="both" />
          </DxChart>
        </div>
      </div>
    </div>
    <div
      v-if="DEVICE_PLATFORM !== 'android'"
      class="controls-pane"
      style="padding-bottom: 1rem;"
    >
      <DxButton
        id="export"
        style="background-color: #616B7C; padding: 0.5rem;"
        icon="export"
        type="default"
        :text="$t('exportGraphs')"
        @click="onClickExport()"
      />
    </div>
    <f7-block-footer
      class="content-action-botton"
    >
      <f7-link
        popover-open=".popover-menu"
        data-popover=".links-popover"
        class="dx-btn-success open-air dx-btn-see-more sm-popover"
      >
        {{ $t('seeMore') }}
      </f7-link>
      <f7-popover class="popover-menu links-popover">
        <f7-list>
          <f7-list-item
            link="/cropResult/"
            popover-close
            :title="$t('LeftPanel_subtitle_crop')"
          />
          <f7-list-item
            link="/floorResult/WATER-CONTENT-DRAINAGE-LEACHING/"
            popover-close
            :title="$t('LeftPanel_subtitle_floor')"
          />
          <f7-list-item
            link="/irrigationResultEx/"
            popover-close
            :title="$t('LeftPanel_subtitle_irrigation')"
          />
          <f7-list-item
            link="/contributionNResult/"
            popover-close
            :title="$t('LeftPanel_subtitle_contribution_N')"
          />
        </f7-list>
      </f7-popover>
      <f7-button
        class="dx-btn-cancel color-OpenAir"
        raised
        type="default"
        styling-mode="outlined"
        name="ButtonCancel"
        @click="goToResultOpenAirPage"
      >
        {{ $t("button_back") }}
      </f7-button>
    </f7-block-footer>
  </f7-page>
</template>
<script>
import { mapState } from 'vuex';
import {
  DxChart,
  DxSeries,
  DxArgumentAxis,
  DxCommonSeriesSettings,
  DxLegend,
  DxTitle,
  DxTooltip,
  DxScrollBar,
  DxZoomAndPan,
  DxExport,
  DxValueAxis,
} from 'devextreme-vue/chart';
import DxButton from 'devextreme-vue/button';
import { exportWidgets } from 'devextreme/viz/export';
import navbar from '../../../components/navbar/NavBar.vue';
import { DEVICE_PLATFORM, NUMBER_OF_DECIMALS } from '../../../js/constants';

export default {
  name: 'ClimateResultPage',
  components: {
    navbar,
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxCommonSeriesSettings,
    DxLegend,
    DxTitle,
    DxTooltip,
    DxScrollBar,
    DxZoomAndPan,
    DxExport,
    DxValueAxis,
    DxButton,
  },
  data() {
    return {
      temperature: [],
      humidity: [],
      solarRadiation: [],
      eto: [],
      loaded: false,
      data: [],
      NUMBER_OF_DECIMALS,
      DEVICE_PLATFORM,
    };
  },
  computed: {
    ...mapState('Result', [
      'resultProject',
    ]),
  },
  beforeMount() {
    this.$f7.preloader.show();
    try {
      this.keyName = this.$f7.views.main.router.currentRoute.path;
      this.data = this.resultProject.result.eto.map((eto, index) => ({
        ddp: index,
        eto,
        Tmax: this.resultProject.result.temperature_max[index],
        Tmin: this.resultProject.result.temperature_min[index],
        Tmed: this.resultProject.result.temperature_med[index],
        RHmax: this.resultProject.result.humidity_max[index],
        RHmin: this.resultProject.result.humidity_min[index],
        PRadi: this.resultProject.result.radiation[index],
      }));
      this.loaded = true;
    } catch (e) {
      console.log(e);
    } finally {
      this.$f7.preloader.hide();
    }

    this.$f7.preloader.hide();
  },
  methods: {
    customizeTooltip(pointInfo) {
      return {
        html: `<div><div class='tooltip-header'></div><div class='tooltip-body'>
          <span class='bold'> Tiempo (ddp): </span>${pointInfo.argument} </span> </div>
          <span class="bold"> ${pointInfo.seriesName}: </span> ${Number(pointInfo.valueText).toFixed(this.NUMBER_OF_DECIMALS)}
        </span> </div></div></div>`,
      };
    },
    onLegendClick({ target: series }) {
      if (series.isVisible()) {
        series.hide();
      } else {
        series.show();
      }
    },
    goToResultOpenAirPage() {
      this.$f7.views.main.router.navigate('/tabs-result/', { reloadCurrent: true });
    },
    onClickExport() {
      const chart1 = this.$refs.chart1.instance;
      const chart2 = this.$refs.chart2.instance;
      const chart3 = this.$refs.chart3.instance;
      const chart4 = this.$refs.chart4.instance;

      if (DEVICE_PLATFORM === 'android') {
        this.$refs.chart1.instance.exportTo(`${this.resultProject.name} - Clima - Temperatura`, 'png');
        this.$refs.chart2.instance.exportTo(`${this.resultProject.name} - Clima - Humedad Relativa`, 'png');
        this.$refs.chart3.instance.exportTo(`${this.resultProject.name} - Clima - Radiación Solar Diaria`, 'png');
        this.$refs.chart4.instance.exportTo(`${this.resultProject.name} - Clima - ETo Diaria`, 'png');
      } else {
        exportWidgets([[chart1, chart2, chart3, chart4]], {
          fileName: `${this.resultProject.name} - RESULTADOS CLIMA`,
          format: 'PNG',
        });
      }
    },
    onFileSaving(e) {
      if (DEVICE_PLATFORM === 'android') {
        cordova.plugins.saveDialog.saveFile(e.data, `${e.fileName}.${e.format}`).then((uri) => {
          console.info('The file has been successfully saved to', uri);
        }).catch((reason) => {
          console.warn(reason);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../css/mixins";
.transparent {
  .content-charts {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .chart {
      padding-bottom: 4rem;
      padding-left: 1rem;
      padding-right: 1rem;
      flex-basis: 100%;
      @include md {
        flex-basis: 45%;
      }
    }
  }
}
.block-title-result {
  border-bottom: 1px solid #51A411;
}
</style>
